import React, { FC, memo } from 'react';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';

import dynamicSize from '@webtrader/core/dynamic-size';

import { IVectorIconProps } from './index';

MaterialIcons.loadFont();

export type MaterialIconsName =
  | 'close'
  | 'build'
  | 'devices'
  | 'refresh'
  | 'payment'
  | 'filter-vintage'
  | 'fullscreen'
  | 'fullscreen-exit'
  | 'double-arrow'
  | 'arrow-drop-up'
  | 'notifications'
  | 'notifications-none'
  | 'notifications-active'
  | 'arrow-drop-down'
  | 'phone-iphone'
  | 'info-outline'
  | 'support-agent'
  | 'person-outline'
  | 'arrow-back-ios'
  | 'arrow-forward-ios'
  | 'stacked-bar-chart'
  | 'smartphone'
  | 'update'
  | 'sort'
  | 'lock-outline'
  | 'groups'
  | 'help-outline'
  | 'error-outline'
  | 'file-download'
  | 'keyboard-arrow-up'
  | 'keyboard-arrow-down'
  | 'fingerprint'
  | 'face-retouching-natural';

const MaterialIconsIcon: FC<IVectorIconProps<MaterialIconsName>> = (props) => {
  const { name, size = 20, color, ...restProps } = props;

  return <MaterialIcons {...restProps} name={name} color={color} size={dynamicSize.convertSize(size)} />;
};

export default memo(MaterialIconsIcon);
